import { render, staticRenderFns } from "./DashboardAreaSettingModal.vue?vue&type=template&id=1c21d9f6&"
import script from "./DashboardAreaSettingModal.vue?vue&type=script&lang=js&"
export * from "./DashboardAreaSettingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c21d9f6')) {
      api.createRecord('1c21d9f6', component.options)
    } else {
      api.reload('1c21d9f6', component.options)
    }
    module.hot.accept("./DashboardAreaSettingModal.vue?vue&type=template&id=1c21d9f6&", function () {
      api.rerender('1c21d9f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/modal/DashboardAreaSettingModal.vue"
export default component.exports